import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
import { getData } from "../../../utils/api";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);
  const [features, setFeatures] = useState([]); // Store features
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [showModal, setShowModal] = useState({ code: 0, message: "", });

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    control,
    trigger,
    setValue,
    setError,  // To manually set validation errors
    clearErrors, // To clear validation errors
  } = useForm();
  // const descriptionValue = watch("description");
  // const imageFile = watch("image");

  // Fetch features when component mounts
  useEffect(() => {
    const getFeatures = async () => {
      try {
        const response = await getData("/allfeatures");
        if (response?.success) {
          setFeatures(response.data); // Store the features in state
        } else {
          console.log("Failed to fetch features");
        }
      } catch (error) {
        console.error("Error fetching features", error);
      }
    };
    getFeatures();
  }, []);

  // Handle checkbox selection
  const handleFeatureChange = (feature_id) => {
    setSelectedFeatures((prev) =>
      prev.includes(feature_id)
        ? prev.filter((id) => id !== feature_id) // Remove if already selected
        : [...prev, feature_id] // Add if not selected
    );

    // Clear error when at least one checkbox is selected
    if (selectedFeatures.length > 0) {
      clearErrors("features");
    }
  };

  const onSubmit = async (data) => {
    if (selectedFeatures.length === 0) {
      setError("features", { type: "manual", message: "Please select at least one feature." });
      return; // Stop form submission
    }

    
    try {
      console.log(data);
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("promo_code", data?.promo_code);
      sendData.append("actual_price", data?.actual_price);
      sendData.append("amount", data?.amount);
      sendData.append("use_per_coupon", data?.use_per_coupon);
      sendData.append("validity_in_days", data?.validity_in_days);
      // sendData.append("feature_ids", JSON.stringify(selectedFeatures)); // Send selected features
      sendData.append("feature_ids", JSON.stringify(selectedFeatures));

      const response = await postData(`/masters/subscription`, sendData);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview



  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            subscription
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">


              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Name</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Name"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Name is required",
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Promo Code</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="promo_code"
                          placeholder="promo_code"
                          className={classNames("", {
                            "is-invalid": errors?.promo_code,
                          })}
                          {...register("promo_code", {
                            required: "promo_code is required",
                          })}
                        />
                      </InputGroup>
                      {errors.promo_code && (
                        <span className="text-danger">
                          {errors.promo_code.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Actual Price</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="actual_price"
                          placeholder="actual_price"
                          className={classNames("", {
                            "is-invalid": errors?.actual_price,
                          })}
                          {...register("actual_price", {
                            required: "actual_price is required",
                          })}
                        />
                      </InputGroup>
                      {errors.actual_price && (
                        <span className="text-danger">
                          {errors.actual_price.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Amount</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="amount"
                          placeholder="amount"
                          className={classNames("", {
                            "is-invalid": errors?.amount,
                          })}
                          {...register("amount", {
                            required: "amount is required",
                          })}
                        />
                      </InputGroup>
                      {errors.amount && (
                        <span className="text-danger">
                          {errors.amount.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Use Per Coupon</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="use_per_coupon"
                          placeholder="use_per_coupon"
                          className={classNames("", {
                            "is-invalid": errors?.use_per_coupon,
                          })}
                          {...register("use_per_coupon", {
                            required: "use_per_coupon is required",
                          })}
                        />
                      </InputGroup>
                      {errors.use_per_coupon && (
                        <span className="text-danger">
                          {errors.use_per_coupon.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Validity In Days</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="validity_in_days"
                          placeholder="validity_in_days"
                          className={classNames("", {
                            "is-invalid": errors?.validity_in_days,
                          })}
                          {...register("validity_in_days", {
                            required: "validity_in_days is required",
                          })}
                        />
                      </InputGroup>
                      {errors.validity_in_days && (
                        <span className="text-danger">
                          {errors.validity_in_days.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              {/* Feature Selection Checkboxes */}
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Select Features</Form.Label>
                  <div>
                    {features.map((feature) => (
                      <div key={feature.id} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`feature-${feature.id}`}
                          checked={selectedFeatures.includes(feature.id)}
                          onChange={() => handleFeatureChange(feature.id)}
                        />
                        <label className="form-check-label"
                          htmlFor={`feature-${feature.id}`}
                          style={{ color: 'white' }}
                        >
                          {feature.name}
                        </label>
                      </div>
                    ))}
                  </div>
                  {/* Show error message if no feature is selected */}
                  {errors.features && <span className="text-danger">{errors.features.message}</span>}
                </Form.Group>
              </Col>


              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
